// extracted by mini-css-extract-plugin
export default {"self":"SocialMediaIcon_self__d050u"};